var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activityInfo)?_c('div',[_c('H5PPlayer',{attrs:{"exercise":_vm.activityInfo.activityH5PId,"onXApiStatement":_vm.processStatement}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }